// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080512/js/" + chunkId + "." + {"44":"90d2474a","225":"b093a520","481":"fca89aa1","486":"cee2270b","770":"6b65b1d6"}[chunkId] + ".0.7311771938158965.chunk.js";
};